module.exports = __webpack_public_path__ + "img/edit.cba629ab.svg";